import { Avatar, Box, makeStyles, TableCell, TableRow, Tooltip, Typography } from "@material-ui/core";
import StarIcon from "@material-ui/icons/Star";
import StarOutlineOutlinedIcon from "@material-ui/icons/StarOutlineOutlined";
import clsx from "clsx";
import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { THEME_MODE } from "src/config/constants";
import { addFavoriteToken, removeFavoriteToken } from "src/services/favoriteToken";

const useStyle = makeStyles((theme) => ({
  starCell: {
    "&:hover": {
      background: theme.palette.type === THEME_MODE.DARK ? "#07111C" : "#F2F4F7",
    },
  },
  firstCell: {
    position: "sticky",
    left: 0,
    zIndex: 1,
    backgroundColor: theme.palette.background.paper,
  },
  cell: {
    cursor: "pointer",
  },
  blueText: {
    color: `${theme.palette.primary.main} !important`,
    fontSize: "16px",
    fontWeight: 500,
  },
}));

export default function RankingRow({ rowData }) {
  const cls = useStyle();
  const history = useHistory();
  const [isFavorite, setIsFavorite] = useState(rowData["isFavorite"]);

  useEffect(() => {
    setIsFavorite(rowData["isFavorite"]);
  }, [rowData]);

  const onRowClick = () => {
    history.push(`/tokens-health/${rowData.token_id}`);
  };

  const onStarClick = (event) => {
    event.stopPropagation();
    if (isFavorite) {
      removeFavoriteToken(rowData.token_id);
      setIsFavorite(false);
    } else {
      addFavoriteToken(rowData.token_id);
      setIsFavorite(true);
    }
  };

  return (
    <TableRow onClick={() => onRowClick()} className={cls.row}>
      <Tooltip title={isFavorite ? "Remove from favorites" : "Add to favorites"}>
        <TableCell colSpan onClick={(e) => onStarClick(e)} className={clsx(cls.starCell, cls.firstCell)}>
          {isFavorite ? <StarIcon color="primary" /> : <StarOutlineOutlinedIcon />}
        </TableCell>
      </Tooltip>
      <TableCell className={cls.firstCell}>
        <Typography>{rowData.rank}</Typography>
      </TableCell>
      <TableCell className={cls.firstCell}>
        <Box display="flex" alignItems="center">
          <Avatar src={rowData.img_url} style={{ marginRight: 10, width: 30, height: 30 }} />{" "}
          <Typography>{rowData.symbol}</Typography>
        </Box>
      </TableCell>
      <TableCell>
        <Typography className={cls.blueText}>{rowData.credit_score}</Typography>
      </TableCell>
      <TableCell>
        <Typography>{rowData.market_cap_score}</Typography>
      </TableCell>
      <TableCell>
        <Typography>{rowData.trading_over_cap_score}</Typography>
      </TableCell>
      <TableCell>
        <Typography>{rowData.price_over_highest_score}</Typography>
      </TableCell>
      <TableCell>
        <Typography>{rowData.price_stability_score}</Typography>
      </TableCell>
      <TableCell>
        <Typography>{rowData.number_of_transaction_score}</Typography>
      </TableCell>
      <TableCell>
        <Typography>{rowData.holders_score}</Typography>
      </TableCell>
      <TableCell>
        <Typography>{rowData.holder_distribution_score}</Typography>
      </TableCell>
    </TableRow>
  );
}
